import React from 'react';
import {
	Grid,
	TextField,
	Box,
	Typography,
} from '@mui/material';
import { User } from '../../gql/graphql';
import { useShopDetails } from '../../hooks/use-shop';

interface BasicInfoTabProps {
	userData: Partial<User>;
	updateUserData: (updates: Partial<User>) => void;
}

function BasicInfoTab({ userData, updateUserData }: BasicInfoTabProps) {
	const { shopId } = useShopDetails();

	// Initialize shopId if not set
	React.useEffect(() => {
		if (!userData.shopId) {
			updateUserData({ shopId });
		}
	}, []);

	const handleChange = (field: keyof User) => (
		event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		updateUserData({ [field]: event.target.value });
	};

	return (
		<Box>
			<Typography variant="h6" gutterBottom>
				Basic User Information
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
				Enter the user's contact details
			</Typography>

			<Grid container spacing={3}>
				{/* First Name */}
				<Grid item xs={12} md={6}>
					<TextField
						fullWidth
						required
						label="First Name"
						name="firstName"
						value={userData.firstName || ''}
						onChange={handleChange('firstName')}
						helperText="User's first name"
					/>
				</Grid>

				{/* Last Name */}
				<Grid item xs={12} md={6}>
					<TextField
						fullWidth
						label="Last Name"
						name="lastName"
						value={userData.lastName || ''}
						onChange={handleChange('lastName')}
						helperText="User's last name"
					/>
				</Grid>

				{/* Email */}
				<Grid item xs={12} md={6}>
					<TextField
						fullWidth
						required
						label="Email"
						name="email"
						type="email"
						value={userData.email || ''}
						onChange={handleChange('email')}
						helperText="User's email address"
					/>
				</Grid>

				{/* Phone */}
				<Grid item xs={12} md={6}>
					<TextField
						fullWidth
						required
						label="Phone"
						name="phone"
						value={userData.phone || ''}
						onChange={handleChange('phone')}
						helperText="10-digit phone number"
					/>
				</Grid>
			</Grid>
		</Box>
	);
}

export default BasicInfoTab;
